import Highcharts from 'highcharts/highstock';

export const createLastPriceLabel = (dataLabels: Highcharts.PointLabelObject, color: string) => {
  const last = dataLabels.series.points.at(-1)?.index;
  if (dataLabels.point.index === last) {
    const decimalPlaces = dataLabels.series.userOptions.custom?.decimalPlaces;
    const value = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    }).format(dataLabels.y ?? 0);
    const htmlElementStyle =
      `color: ${color};` +
      ' display: inline-flex; padding: 0 4px 0 4px; justify-content: center;text-align: center;align-items: center;  width:55px;height:15px;font-size: 10px;font-style: normal;font-weight: 400;line-height: normal;' +
      `background-color:${dataLabels.series.color};`;
    return `<div style="${htmlElementStyle}">${value}</div>`;
  }
};
